import React from 'react'
import styled from 'styled-components'
import { Badge } from 'rebass'

export default styled(({primary, secondary, alignSelf, ...others}) =>
  <Badge {...others} />
)`
  ${props => props.alignSelf && `align-self: ${props.alignSelf};`}
  ${props => props.primary && `background: ${props.theme.colors.primary};`}
  ${props => props.secondary && `background: ${props.theme.colors.secondary};`}
`


// WEBPACK FOOTER //
// ./src/components/Badge.js